<template>
    <div>
        <SubmissionStatusOverviewComponent />
        <div class="px-4 md:px-20 pb-20">
            <ApprovalInformationComponent />
            <PersonalDetailsComponent />
            <EmploymentDetailsComponent />
            <InvestmentExperienceComponent />
            <InvestmentObjectivesComponent />
            <FinancialCircumstancesComponent />
            <BankingDetailsComponent />
            <LegalDocumentationComponent />
            <DeclarationsComponent />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SubmissionStatusOverviewComponent from "@adminComponents/partials/submission-details/SubmissionStatusOverviewComponent";
import PersonalDetailsComponent from "@adminComponents/partials/submission-details/PersonalDetailsComponent";
import EmploymentDetailsComponent from "@adminComponents/partials/submission-details/EmploymentDetailsComponent";
import InvestmentExperienceComponent from "@adminComponents/partials/submission-details/InvestmentExperienceComponent";
import InvestmentObjectivesComponent from "@adminComponents/partials/submission-details/InvestmentObjectivesComponent";
import FinancialCircumstancesComponent from "@adminComponents/partials/submission-details/FinancialCircumstancesComponent";
import BankingDetailsComponent from "@adminComponents/partials/submission-details/BankingDetailsComponent";
import LegalDocumentationComponent from "@adminComponents/partials/submission-details/LegalDocumentationComponent";
import DeclarationsComponent from "@adminComponents/partials/submission-details/DeclarationsComponent";
import ApprovalInformationComponent from "@adminComponents/partials/submission-details/ApprovalInformationComponent";

export default {
    name: "AdminUserSubmissionPage",
    components: {
        SubmissionStatusOverviewComponent,
        PersonalDetailsComponent,
        EmploymentDetailsComponent,
        InvestmentExperienceComponent,
        InvestmentObjectivesComponent,
        FinancialCircumstancesComponent,
        BankingDetailsComponent,
        LegalDocumentationComponent,
        DeclarationsComponent,
        ApprovalInformationComponent
    },
    computed: {
        ...mapGetters(["global", "submission"]),
    },
    data: function () {
        return {};
    },
    methods: {
        ...mapActions(["doGetSubmission", "showHideGlobalLoader", "doGetSubmissionGbgReportDocument"])
    },
    mounted() {
        this.showHideGlobalLoader({ isLoading: true, overlay: false });
        this.doGetSubmission(this.$route.params.user).then((response) => {
            this.showHideGlobalLoader({ isLoading: false });
        });
        this.doGetSubmissionGbgReportDocument(this.$route.params.user).then((response) => {
            this.showHideGlobalLoader({ isLoading: false });
        });
    },
};
</script>
